import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=33a6b22f&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33a6b22f')) {
      api.createRecord('33a6b22f', component.options)
    } else {
      api.reload('33a6b22f', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=33a6b22f&", function () {
      api.rerender('33a6b22f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23OF5XPc07hMq/JS/comp/FavElement.vue"
export default component.exports